'use client';

import { useTranslations } from 'next-intl';
import CWButton from '@/context/global/components/g00/g00-d00-g006-cw-button';
import ErrorIllustrationSVG from '@/context/global/assets/Plug';

export interface ErrorSuspenseProps {
  message?: string;
  onClickBackToLogin?: () => void;
}

const ErrorSuspense = ({ message, onClickBackToLogin }: ErrorSuspenseProps) => {
  const t = useTranslations('KaraokeError');

  const displayMessage = message ?? t('accountSuspended');

  return (
    <div className="bg-background mt-10 flex min-h-screen w-full items-start justify-center px-4 md:mt-0 md:items-center">
      <div className="flex flex-col items-center gap-12 sm:gap-16 lg:gap-[82px]">
        {/* Error Illustration and Text */}
        <div className="flex flex-col items-center gap-6 sm:gap-8 lg:gap-[31px]">
          {/* Illustration */}
          <ErrorIllustrationSVG className="h-auto w-[200px] sm:w-[300px] lg:w-[439px]" />

          {/* Text Content */}
          <div className="flex flex-col items-center text-center text-white">
            <p className="text-4xl font-bold leading-tight sm:text-5xl lg:text-[70px] lg:leading-[88px]">
              {t('oops')}
            </p>
            <p className="mt-2 text-xl font-normal sm:text-2xl lg:text-[40px]">
              {displayMessage}
            </p>
          </div>
        </div>

        {/* Button */}
        <div className="w-full max-w-[280px] sm:max-w-[280px] lg:max-w-[300px]">
          <CWButton
            title={t('backToLogin')}
            variant="white"
            className="h-[56px] rounded-lg text-[28px] font-bold sm:h-[60px] sm:text-[32px] lg:h-[70px] lg:text-[38px]"
            onClick={onClickBackToLogin}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorSuspense;
